import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepInformationFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepInformationFormContainer.jsx';

const EditProfileStepInformation = ({ projectId, stakeholderId, slug }) => (
  <>
    <Helmet>
      <title>Edit Stakeholder | ChangeSync</title>
    </Helmet>
    <StepInformationFormContainer
      projectId={projectId}
      stakeholderId={stakeholderId}
      slug={slug}
    />
  </>
);

EditProfileStepInformation.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  stakeholderId: Number(query.stakeholderId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditProfileStepInformation));
